import { SET_ROOMS, UPDATE_ROOMS } from '../constants/rooms';

export const setRoomsAction = (payload) => ({
  type: SET_ROOMS,
  payload,
});

export const updateRoomsAction = (payload) => ({
  type: UPDATE_ROOMS,
  payload,
});
